import * as S from './styles'

export const Spinner = ({ size, absolute, borderSize }) => (
  <S.SmallSpinner
    size={size}
    absolute={absolute}
    borderSize={borderSize}
  ></S.SmallSpinner>
)
